// src/components/items/detail/LastTradesPriceGraph.js
import React from 'react';
import {Line} from 'react-chartjs-2';
import {
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    TimeScale,
    Title,
    Tooltip
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import {centsToString} from 'util/cashFormatter';

ChartJS.register(LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, Filler);

const LastTradesPriceGraph = ({tradeData}) => {
    const lastTenTrades = tradeData?.lastTenTrades.sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
    ) || [];

    const prices = lastTenTrades.map(trade => trade.price);
    const labels = lastTenTrades.map(trade => new Date(trade.timestamp));

    const chartData = {
        labels: labels, // Date objects or ISO strings
        datasets: [
            {
                label: 'Price',
                data: prices,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true, // 'fill' option needs the Filler plugin
                tension: 0.2,
            },
        ],
    };

    const options = {
        interaction: {
            mode: 'x',
            intersect: false
        },
        scales: {
            x: {
                type: 'time', // Set the x-axis to 'time' to enable time-based scaling
                time: {
                    unit: 'day', // Display unit (adjustable to 'hour', 'minute', etc.)
                    tooltipFormat: 'PPpp', // Custom tooltip date format (based on date-fns)
                },
            },
            y: {
                beginAtZero: true,
                min: 0,
                ticks: {
                    callback: function (value) {
                        return `${centsToString(value)}`;
                    }
                }
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const price = context.raw;
                        const date = new Date(context.label).toLocaleString(); // Format date in tooltip
                        return `Price: ${centsToString(price)}, Sold on: ${date}`;
                    },
                },
            },
        },
    };

    return <Line data={chartData} options={options}/>;
};

export default LastTradesPriceGraph;
